import React ,{ useState, useEffect } from 'react';
import {
    TextInput,
    DateInput,
    SelectInput,
    Edit,
    TabbedForm,
    FormTab,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    SimpleForm,
    useNotify
} from 'react-admin';
import {useFormContext} from "react-hook-form";
import { Redirect } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import WeightVolume from './WeightVolume'
import jwt_decode from 'jwt-decode'
import Pressure from './Pressure'
import Pluse from './Pulse'
import Temp from './Temp'
import Hemato from './Hemato'
import Protein from './Protein'
import Allergies from '../controls/Allergies'
import SelectProQuest from '../controls/SelectProQuest';
import Initview from './InitView'
import Questionnaireview from './QuestionnaireView'
import ControlNum  from './ControlNum'
import Sign from '../controls/Signature';
import FileUpload from '../controls/FileUpload'
import PhlebotoView from './PhlebotoView'
import SanitizedTextInput from '../controls/SanitizedTextInput';
import SoftGoodUsageLoader from '../controls/SoftGoodUsageLoader';
import { snapshot as softGoodsSnapshot } from '../controls/softGoodsStore';
import { SoftGoodsLotRows, SoftGoodsQtyRows } from './SoftGoodsRows';
import MachineInput from './MachineInput';
import AutoSave from './AutoSave';
import { apiGet } from '../controls/supplyApi';
import {
    EMPTY_INCIDENT,
    hasIncident,
    incidentToApi,
    incidentFromApi,
} from './incident';
import TimeInput from '../controls/TimeInput';
import ErrorBoundary from '../ErrorBoundary';
import Button from "@material-ui/core/Button";
import {useForm} from "react-final-form";
import IncidentDialog from './IncidentDialog'; // Ensure correct path
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';


const { 
    REACT_APP_INCIDENT_LIST_URL, 
    REACT_APP_INCIDENT_DOWNLOAD_URL, 
    REACT_APP_INCIDENT_DELETE_URL,
    REACT_APP_INCIDENT_UPLOAD_URL,
    REACT_APP_API_ENDPOINT
} = process.env;

var donorSign = null;
let ssn = null
let data = null
let process_id = null;

const editStyles = {
    formTable: {
        margin: 'auto',
        width: '100%',
        fontSize: '12px',
        '& td': { padding: '6px 10px', verticalAlign: 'top' },
        '& tr:hover': { backgroundColor: 'transparent' },
        '& .MuiFormControl-root': { width: '100%' },
    },
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '40em' },

    twentyFive: {
        width: '25%',
        align: 'center'
    },
    twenty: {
        width: '20%',
        align: 'center'
    },
    sixteen: {
        width: '16.66%',
        align: 'center'
    },
    uploadButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'center',
        width: '6em',
    },
    removeButton: {
      backgroundColor: '#fa3a2f',
      "&:hover": {
          backgroundColor: '#b30706',
      },
      textAlign: 'center', 
      verticallAign: 'middle',
      borderRadius: '15px',
      color: 'white',
      fontWeight: 'normal',
      float: 'center',
      width: '2em',
    },
    downloadButton: {
      backgroundColor: '#3f51b5',
      "&:hover": {
          backgroundColor: 'navy',
      },
      textAlign: 'center', 
      verticallAign: 'middle',    
      borderRadius: '15px',
      color: 'white',
      fontWeight: 'bold',
      float: 'center',
      width: '2em',
    },
};


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const ProcessingEditActions = () => (
    <CardActions style={cardActionStyle}>
        <ListButton 
        basePath={'/processing?filter=%7B"ssn"%3A"' + ssn +'"%7D&order=DESC&page=1&perPage=25&sort=id'} 
        label='Processing List'
        />
    </CardActions>
);



const OneTwo = [
    {
        id: '0',
        name: '0'
    },
    {
        id: '1',
        name: '1'
    },
    {
        id : '2',
        name: '2'
    }
  ]

  // The Plasmacell-C Kit quantity choices moved to SoftGoodsRows, which owns
  // the whole soft goods block now.

const leftRight = [
    {
        id: 'L',
        name: 'Left'
    },
    {
        id : 'R',
        name: 'Right'
    }
  ]
  const yesNo = [
    {
        id: 'Yes',
        name: 'Yes'
    },
    {
        id : 'No',
        name: 'No'
    },
    {
        id : 'N/A',
        name: 'N/A'
    }
  ]

  const YesNoExt = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    },
    {
        id : '/',
        name: 'N/A'
    }
  ]

  const YesNo = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    }
  ]

  const deferralCodes = [

    {
        id: 'PR',
        name: 'Permanently rejected'
    },
    {
        id : 'TD',
        name: 'Temporarly Deferred'
    },
    {
        id: 'N/A',
        name: 'Not applicable'
    }
  ]




const GetKey=({ record }) => (
    ssn = (record.ssn)? record.ssn:ssn,
    //console.log(record),
    process_id = (record.process_id)? record.process_id : '',
    data = record,
    (ssn)? '': <Redirect to="/donors" />
);

const GetFileUpload=({classes, record}) => (
    <FileUpload 
        classes={classes}  
        listUrl={`${REACT_APP_INCIDENT_LIST_URL}/${process_id}`}  
        id={process_id}  
        deleteUrl={`${REACT_APP_INCIDENT_DELETE_URL}/${process_id}`} 
        downloadUrl={`${REACT_APP_INCIDENT_DOWNLOAD_URL}/${process_id}`} 
        uploadUrl={`${REACT_APP_INCIDENT_UPLOAD_URL}`}
        isEdit={true}
    />
)

const setDonSignatureValue=(image)=>{
    donorSign = image;
}

/* cleanIncidentData used to live here. It read `incidentDate` while the dialog
   wrote `date`, so it would have dropped the date even if it had been called -
   and it never was, being commented out of the save. Replaced by
   incidentToApi in ./incident, which owns the mapping in both directions. */



/**
 * Soft goods lot usage, prepared for the API.
 *
 * `softgood_usage` is the full picture of what this donation is holding, and
 * the server reconciles inventory against it - anything it names is consumed,
 * anything it omits is given back. That makes it dangerous to send when we are
 * not sure we know the whole picture, so it only goes out once
 * SoftGoodUsageLoader has read back what the ledger already holds. Until then
 * the key is left off the request entirely and the server leaves inventory
 * alone.
 *
 * Read from softGoodsStore rather than form state, for the same reason the
 * donor signature is: seeding form state on open would mark an untouched
 * record dirty.
 */
const softGoodUsagePayload = () => {
  const softGoods = softGoodsSnapshot();
  if (!softGoods.loaded) {
    return {};
  }
  return {
    softgood_usage: (softGoods.lines || []).map(line => ({
      receipt_id: line.receipt_id,
      qty: Number(line.qty) || 0,
    })),
  };
};

/**
 * The write payload, shared by the Save button and the background autosave so
 * the two can never drift into sending different things.
 */
const buildSavePayload = (data, donorSign, incidentData) => ({
  ...data,
  donor_sign: donorSign,
  ...softGoodUsagePayload(),
  // Spreads to nothing when there is no incident, so an ordinary donation adds
  // no incident fields and the server leaves the report table alone.
  ...incidentToApi(incidentData),
});

/**
 * react-admin injects handleSubmitWithRedirect, invalid, pristine, saving and
 * friends into whatever is passed as a form's `toolbar`. They must be
 * forwarded to <Toolbar>, which is what clones handleSubmitWithRedirect onto
 * the SaveButton - without it the button renders fine and then throws
 * "is not a function" the moment it is clicked, which is exactly what this
 * screen did.
 *
 * The button stays clickable on an untouched record: Toolbar only applies its
 * pristine-based `disabled` to the SaveButton it creates itself, not to one
 * passed as a child.
 *
 * The toolbar is also where <AutoSave> is mounted. It is the only node all
 * three forms on this screen render, it sits inside the form context so it can
 * read form state, and unlike a tab it is never conditionally dropped - so one
 * instance here covers the supervisor tabs, the plasma processor form and the
 * phlebotomy form without any of them running two savers at once.
 */
const ProcessingToolbar = ({ incidentData, incidentTouched, donorSign, ssn, ...toolbarProps }) => {
  const notify = useNotify();

  // The incident report is React state rather than form state, so autosave
  // needs telling when it moves - see the AutoSave props of the same name.
  const incidentKey = JSON.stringify(incidentToApi(incidentData) || {});

  return (
    <Toolbar {...toolbarProps}>
      <SaveButton
        label="save"
        transform={(data) => ({
          ...buildSavePayload(data, donorSign, incidentData),
          // Submit only runs once validation passes, so a record saved from
          // this button is by definition complete rather than a draft.
          is_draft: 0,
        })}
        //onSuccess={() => notify('Saved successfully', { type: 'info' })}
       // onFailure={(e) =>
         // notify(`Failed to save: ${e?.message || 'Unknown error'}`, { type: 'warning' })
        //}
        //redirect={`/`}
        redirect={`/processing?filter=%7B"ssn"%3A"${ssn}"%7D&order=DESC&page=1&perPage=25&sort=id`}
        submitOnEnter={true}
      />
      <AutoSave
        record={toolbarProps.record}
        resource={toolbarProps.resource}
        transform={(data) => buildSavePayload(data, donorSign, incidentData)}
        externalKey={incidentKey}
        externalDirty={!!incidentTouched}
      />
    </Toolbar>
  );
};



const ProcessingEdit =({ classes, ...props }) => {

    const [openIncident, setOpenIncident] = useState(false);
   // const [openReaction, setOpenReaction] = useState(false);
    //const [donorReactionData, setDonorReactionData] = useState(null);
   

    /**
     * The donor reaction / incident report.
     *
     * It is not part of the processing record and never arrives with it - it
     * lives in its own table, keyed by this donation - so it is loaded
     * separately below. It also stays out of form state on purpose: seeding
     * the form on open would mark an untouched worksheet dirty, the same trap
     * the soft goods loader and the signature both avoid.
     */
    const [incidentData, setIncidentData] = useState(EMPTY_INCIDENT);

    /**
     * Whether a person changed the report, as opposed to it arriving from the
     * loader below. Autosave needs the difference: loading a donation must not
     * write it straight back, but adding a report must save even on a
     * worksheet nobody has otherwise touched.
     */
    const [incidentTouched, setIncidentTouched] = useState(false);

    const handleIncidentSave = (formData) => {
        setIncidentData(formData);
        setIncidentTouched(true);
    };

    // react-admin routes the record id in through `match`; `props.id` covers
    // the places this is rendered directly.
    const processId = props.id
        || (props.match && props.match.params ? props.match.params.id : null);

    useEffect(() => {
        if (!processId) {
            setIncidentData(EMPTY_INCIDENT);
            return undefined;
        }

        let cancelled = false;
        setIncidentTouched(false);

        apiGet(`donorincident/${processId}`)
            .then((row) => {
                if (!cancelled) {
                    // The endpoint answers with null when this donation had no
                    // incident, which is the ordinary case.
                    setIncidentData(incidentFromApi(row));
                }
            })
            .catch(() => {
                // A report that cannot be read must not block the worksheet.
                // Leaving the dialog empty is safe: an empty report is never
                // sent, so nothing already stored can be overwritten by it.
                if (!cancelled) { setIncidentData(EMPTY_INCIDENT); }
            });

        return () => { cancelled = true; };
    }, [processId]);


    const CdCsVerify = () => {
        const form = useForm();
        const [status, setStatus] = React.useState("");
        const [loading, setLoading] = React.useState(false);
        const handleCDCS = async () => {
            setLoading(true); // Set loading to true
            setStatus("");
            //get last 5 chars of ssn
            const last5Digits = ssn.substring(ssn.length - 5);
            console.log(data, last5Digits);
            const token = localStorage.getItem('token');
            try {
                const result = await fetch(REACT_APP_API_ENDPOINT + "/cdcs/check-donations", {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        "SSN": last5Digits,
                        "last_name": data.last_name
                    }),
                });

                const json = await result.json();

                if (json) {
                    if (json.status_code === 0) {
                        let donations = json.message.donations;
                        form.change('cdcs_inq_num', json.message.inquiryReferenceNumber);
                        const currentDate = new Date();
                        const recentDonations = donations.filter(donation => {
                            const donationDate = new Date(donation.donationDate);
                            const diffInDays = (currentDate - donationDate) / (1000 * 60 * 60 * 24);
                            return diffInDays <= 7;
                        });
                        if (recentDonations.length >= 2) {
                            recentDonations.sort((a, b) => new Date(b.donationDate) - new Date(a.donationDate));
                            setStatus("MAT");
                            const deferralDate = new Date(recentDonations[0].donationDate);
                            const deferralExpiryDate = new Date(deferralDate);
                            deferralExpiryDate.setDate(deferralExpiryDate.getDate() + 7);
                            form.change("deferral_code","TD");
                            form.change("deferral_exp_date",deferralExpiryDate.toISOString().split('T')[0]);
                            form.change("deferral_date",deferralDate.toISOString().split('T')[0]);
                        } else {
                            form.change("deferral_code","N/A");
                            form.change("deferral_exp_date","");
                            form.change("deferral_date","");
                            setStatus("NOT");
                        }
                    } else {
                        setStatus("ERR");
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }

        return(
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <SanitizedTextInput source="cdcs_inq_num"
                                        label=""
                                        validate={required()}/>
                    <Button disabled={loading} style={{height: '45px', marginTop: '10px', marginLeft: '10px'}}
                            variant="contained" color="primary"
                            onClick={handleCDCS}> {loading ? 'Verifying...' : 'Verify'} </Button>
                </div>
                {(status!="")&& (
                    <label style={{marginTop: '10px', color: status.includes('NOT') ? 'green' : 'red'}}>
                        {status == "NOT" ? "A deferral matching the search criteria was NOT FOUND" : (status == "MAT" ? "There was a MATCH and a deferral was found matching the search criteria" : "Error in processing inquiry")}
                    </label>
                )}
            </div>
        );
    }

    return (
        <ErrorBoundary>
            <div>
                {(((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 3 &&
                    (((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 4 &&
                            (((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).code : '') !== 'PLAP' &&
                            <Edit
                                title='Donor Processing Worksheet'
                                {...props}
                                actions={<ProcessingEditActions/>}
                            >

                                <TabbedForm toolbar={<ProcessingToolbar incidentData={incidentData} incidentTouched={incidentTouched} donorSign={donorSign} ssn={ssn} />}>

                                    {(((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 4 &&
                                        (((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 6 &&
                                        <FormTab label="History Questionnaire" id='history'>
                                            <Allergies/>
                                            <GetKey/>
                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell style={{width: "48%"}}><TextInput source="ssn"
                                                                                                     defaultValue={(props && props.location) ? (props.location.search ? (props.location.search).split('=')[1] : ssn) : ssn}
                                                                                                     disabled/></TableCell>
                                                        <TableCell align="center" bgcolor="silver" height="60"> <b>Since
                                                            you
                                                            last donated plasma:</b></TableCell>
                                                    </TableRow>
                                                    <TableRow>

                                                        <SelectProQuest id='healthy' field='healthy' targetvalue='Y'
                                                                        label='1. Are you feeling healthy and well today?'
                                                                        choices={YesNo} validate={required()}/>
                                                        <SelectProQuest id='tattoo' field='tattoo' targetvalue='N'
                                                                        label='11. Have you gotten a tattoo or had one touched up?'
                                                                        choices={YesNo} validate={required()}/>
                                                    </TableRow>
                                                    <TableRow>
                                                        <SelectProQuest id='any_medications' field='any_medications'
                                                                        targetvalue='N'
                                                                        label='2. Since you last donated plasma have you taken any medications on the medication list?'
                                                                        choices={YesNo} validate={required()}/>
                                                        <SelectProQuest id='piercing' field='piercing' targetvalue='N'
                                                                        label='12. Have you had an ear or body piercing?'
                                                                        choices={YesNo} validate={required()}/>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left" bgcolor="silver" height="60"><b>Since
                                                            you last
                                                            donated plasma:</b></TableCell>
                                                        <SelectProQuest id='surgery' field='surgery' targetvalue='N'
                                                                        label='13. Have you had surgery or a diagnostic, medical or dental procedure?'
                                                                        choices={YesNo} validate={required()}/>
                                                    </TableRow>
                                                    <TableRow>
                                                        <SelectProQuest id='pregnant' field='pregnant' targetvalue='N'
                                                                        label='3. Female donors:  Have you been pregnant or are you pregnant now?'
                                                                        choices={YesNoExt} validate={required()}
                                                                        altvalue='/'/>
                                                        <SelectProQuest id='acupunture' field='acupunture'
                                                                        targetvalue='N'
                                                                        label='14. Have you had acupunture?'
                                                                        choices={YesNo}
                                                                        validate={required()}/>
                                                    </TableRow>
                                                    <TableRow>

                                                        <SelectProQuest id='new_problem' field='new_problem'
                                                                        targetvalue='N'
                                                                        label='4. Have you had any new medical problems or diagnoses?'
                                                                        choices={YesNo} validate={required()}/>
                                                        <TableCell align="center" bgcolor="silver"><b>Additional
                                                            Questions</b></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <SelectProQuest id='new_medication' field='new_medication'
                                                                        targetvalue='N'
                                                                        label='5. Have you had any new medical treatments, vaccinations or medications?'
                                                                        choices={YesNo} validate={required()}/>
                                                        <SelectProQuest id='xenotran' field='xenotran' targetvalue='N'
                                                                        label='15. Have you ever received a xenotransplantation product?'
                                                                        choices={YesNo} validate={required()}/>
                                                    </TableRow>
                                                    <TableRow>
                                                        <SelectProQuest id='smallpox' field='smallpox' targetvalue='N'
                                                                        label='6. Have you had contact with someone who had a smallpox vaccination?'
                                                                        choices={YesNo} validate={required()}/>
                                                        <SelectProQuest id='ebola' field='ebola' targetvalue='N'
                                                                        label='16. Have you had Ebola Virus infection or disease?'
                                                                        choices={YesNo} validate={required()}/>
                                                    </TableRow>
                                                    <TableRow>
                                                        <SelectProQuest id='other_center' field='other_center'
                                                                        targetvalue='N'
                                                                        label='7. Have you donated whole blood, platelets or plasma at another center?'
                                                                        choices={YesNo} validate={required()}/>
                                                        <SelectProQuest id='ebola_contact' field='ebola_contact'
                                                                        targetvalue='N'
                                                                        label='17. Have you had close contact in the past 8 weeks with a person confirmed to have Ebola virus infection or disease or a person under investigation for Ebola virus infection or disease in whom diagnosis is pending?'
                                                                        choices={YesNo} validate={required()}
                                                                        altvalue={null}
                                                                        rowspan={'3'}/>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left" bgcolor="silver" height="60"><b>Please
                                                            review
                                                            the Risk Poster</b></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <SelectProQuest id='risk_poster' field='risk_poster'
                                                                        targetvalue='Y'
                                                                        label='8. Did you review the Risk Poster?'
                                                                        choices={YesNo} validate={required()}/>
                                                    </TableRow>
                                                    <TableRow>
                                                        <SelectProQuest id='risk_poster_question'
                                                                        field='risk_poster_question'
                                                                        targetvalue='N'
                                                                        label='9. Do you have any questions about anything mentioned on the Risk Poster?'
                                                                        choices={YesNo} validate={required()}/>
                                                        <SelectProQuest id='evd_exposed' field='evd_exposed'
                                                                        targetvalue='N'
                                                                        label='18. Did you receive a notification by public health authority that you may have been exposed in the past 8 weeks to a person with EVD?'
                                                                        choices={YesNo} validate={required()}
                                                                        altvalue={null}
                                                                        rowspan={'2'}/>
                                                    </TableRow>
                                                    <TableRow>
                                                        <SelectProQuest id='risk_poster_apply_you'
                                                                        field='risk_poster_apply_you'
                                                                        targetvalue='N'
                                                                        label='10. Since you last donated plasma, does anything on the Risk Poster apply to you?'
                                                                        choices={YesNo} validate={required()}/>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="left"><SelectInput source="deferral_code"
                                                                                             label="Deferral code"
                                                                                             choices={deferralCodes}/></TableCell>
                                                        <TableCell align="left"><DateInput source="deferral_date"
                                                                                           label="Deferral date"
                                                                                           locales="en-us"/></TableCell>
                                                        <TableCell align="left"><DateInput source="deferral_exp_date"
                                                                                           label="Deferral Exp date"
                                                                                           locales="en-us"/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left" colSpan="3"><TextInput
                                                            source="deferral_comments" label="" rowsMax={4} multiline
                                                            fullWidth
                                                            lable="Deferral comments"/></TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </FormTab>
                                    }

                                    {(((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 4 && (((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 6 &&
                                        <FormTab label="Initial check">
                                            <Allergies/>
                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="left">Name:</TableCell>
                                                        <TableCell colSpan="3" align="left"><TextInput disabled
                                                                                                       source="name"
                                                                                                       label=""/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left">Donor#:</TableCell>
                                                        <TableCell align="left"><SanitizedTextInput disabled
                                                                                                    source="ssn"
                                                                                                    label=""/></TableCell>
                                                        <TableCell align="left">Bleed Date:</TableCell>
                                                        <TableCell><DateInput source="bleed_date" label=""
                                                                              validate={required()}
                                                                              locales="en-us"/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan="3" align="left">Donor Processor Initial For
                                                            Donor
                                                            Record File Review:</TableCell>
                                                        <TableCell align="left"><SanitizedTextInput
                                                            source="initial_review"
                                                            label=""/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan="3" align="left">CDCS Inquiry
                                                            Number:</TableCell>
                                                        <TableCell align="left">

                                                            <CdCsVerify/>
                                                        </TableCell>

                                                    </TableRow>
                                                    {/*
                        <TableRow>  
                            <TableCell colSpan="3" align="left" >{'Donor database check for internal deferrals: Acceptable?'}</TableCell>
                            <TableCell  align="left" ><SelectInput choices={YesNo}  source="deferrals_accept" label="" /></TableCell>
                        </TableRow>        
                        <TableRow>
                            <TableCell colSpan="3" align="left">{'Donor Processor initial For Donor Fingernail Dye Check:'}</TableCell>
                            <TableCell  align="left"><TextInput source="don_prc_initial_for_fing_ckeck" label=""  /></TableCell>
                        </TableRow> 
                        */}
                                                    <TableRow>
                                                        <TableCell align="left"
                                                                   colSpan="3">{'Is your current address and phone number good for the next 8 weeks?'}</TableCell>
                                                        <TableCell align="left"><SelectInput choices={YesNo}
                                                                                             source="is_phone_good"
                                                                                             label=""/></TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="left"><SelectInput source="deferral_code"
                                                                                             label="Deferral code"
                                                                                             choices={deferralCodes}/></TableCell>
                                                        <TableCell align="left"><DateInput source="deferral_date"
                                                                                           label="Deferral date"
                                                                                           locales="en-us"/></TableCell>
                                                        <TableCell align="left"><DateInput source="deferral_exp_date"
                                                                                           label="Deferral Exp date"
                                                                                           locales="en-us"/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left" colSpan="3"><TextInput
                                                            source="deferral_comments" label="" rowsMax={4} multiline
                                                            fullWidth
                                                            lable="Deferral comments"/></TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </FormTab>
                                    }
                                    {(((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 4 && (((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 6 &&
                                        <FormTab label="Donor processing" id="lab">
                                            <Allergies/>
                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>Booth#</TableCell>
                                                        <TableCell>Start Time</TableCell>
                                                        <TableCell>Weight<br/>110-400 lbs</TableCell>
                                                        <TableCell>Collect Volume<br/>690, 825, 880 ml</TableCell>
                                                        <TableCell>Blood Pressure<br/>100-180/50-100 mmHg</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell><SanitizedTextInput source="booth_num"
                                                                                       label=""/></TableCell>
                                                        <TableCell><TimeInput source="start_time"
                                                                              label=""/></TableCell>
                                                        <WeightVolume/>
                                                        <Pressure/>


                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Pulse<br/>56-100 bpm</TableCell>
                                                        <TableCell>Temperature<br/>97-99.4 F</TableCell>
                                                        <TableCell>Hematocrit<br/>Female:38%-54%<br/>Male:39%-54%</TableCell>
                                                        <TableCell>Total<br/>Protein 6.0-9.0 g/dl</TableCell>
                                                        <TableCell>Donor<br/>Processor Initials</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <Pluse/>
                                                        <Temp/>
                                                        <Hemato/>
                                                        <Protein/>
                                                        <TableCell><SanitizedTextInput source="donor_processor_init"
                                                                                       label=""/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Screening Comments: </TableCell>
                                                        <TableCell colSpan="4"><TextInput source="comments_screening"
                                                                                          label=""
                                                                                          multiline
                                                                                          className={classes.comments}/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan="5"><b>Donor Acknowledgment:</b><br/>
                                                            1. I have reviewed the educational material regarding
                                                            infections
                                                            that can be transmittend by my donation, such as, Syphilis,
                                                            HIV,
                                                            Hepatitis B and C.<br/>
                                                            2. I agree not to donate if my donation could result in a
                                                            potential
                                                            risk to people who receive plasma products.<br/>
                                                            3. A sample of my blood will be tested for infections that
                                                            can be
                                                            transmitted by my donation, such as, Syphilis, HIV,
                                                            Hepatitis B and
                                                            C.<br/>
                                                            4. I understand you will attempt to notify me if for any
                                                            reason I
                                                            cannot donate and records will be maintained indicating the
                                                            reason
                                                            for the deferral and the deferral time period.<br/>
                                                            5. I have reviewed the information regarding the potential
                                                            risks and
                                                            hazards of donating Source plasma.<br/>
                                                            6. I have been given opportunity to ask questions and
                                                            understand
                                                            that I may withdraw frm the donation procedure at any
                                                            time.<br/>
                                                            <br/>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan="2">
                                                            Donor Signature:
                                                        </TableCell>
                                                        <TableCell colSpan="3">
                                                            <Sign setSignatureValue={setDonSignatureValue}
                                                                  url={data ? data.donor_signature : null}/>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan="2">Physician Substitute Review from Donors
                                                            Requiring
                                                            Physical (Ini. Req.):</TableCell>
                                                        <TableCell><SanitizedTextInput source="phy_sub_review"
                                                                                       label=""/></TableCell>
                                                        <TableCell>Control Number:</TableCell>
                                                        <TableCell><ControlNum/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Control Desk Review:</TableCell>
                                                        <TableCell colSpan="4"><TextInput source="control_review"
                                                                                          label=""
                                                                                          multiline
                                                                                          className={classes.comments}/></TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="left"><SelectInput source="deferral_code"
                                                                                             label="Deferral code"
                                                                                             choices={deferralCodes}/></TableCell>
                                                        <TableCell align="left"><DateInput source="deferral_date"
                                                                                           label="Deferral date"
                                                                                           locales="en-us"/></TableCell>
                                                        <TableCell align="left"><DateInput source="deferral_exp_date"
                                                                                           label="Deferral Exp date"
                                                                                           locales="en-us"/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="left" colSpan="3"><TextInput
                                                            source="deferral_comments" label="" rowsMax={4} multiline
                                                            fullWidth
                                                            lable="Deferral comments"/></TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </FormTab>
                                    }

                                    {(((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) !== 2 &&
                                        (((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).code : '') !== 'PLAP' &&
                                        <FormTab label="Phlebotomy">
                                            <GetKey/>
                                            {/* Reads back the lots this donation already drew
                                                from inventory, so an edit adjusts by the
                                                difference instead of consuming twice. */}
                                            <SoftGoodUsageLoader/>
                                            <Allergies/>
                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>Control Number</TableCell>
                                                        <TableCell>Donor weight</TableCell>
                                                        <TableCell>Volume collected</TableCell>
                                                        <TableCell>Machine #</TableCell>
                                                        <TableCell>Soft Goods Verified for Defects and Lot Numbers
                                                            initial</TableCell>

                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell><TextInput source="control_num" label=""
                                                                              disabled/></TableCell>
                                                        <TableCell><TextInput source="weight" label=""
                                                                              disabled/></TableCell>
                                                        <TableCell><TextInput source="volume_collected" label=""
                                                                              disabled/></TableCell>
                                                        <TableCell><MachineInput/></TableCell>
                                                        <TableCell><SanitizedTextInput source="sf_lot_init"
                                                                                       label=""/></TableCell>
                                                    </TableRow>
                                                                                                       
                                                    {/* Lot numbers are picked from the released
                                                        soft goods in inventory; the quantities
                                                        below follow from that selection and the
                                                        stock is drawn down on save. */}
                                                    <SoftGoodsLotRows/>
                                                    <SoftGoodsQtyRows ckitDefault='0' />

                                                    <TableRow>
                                                        <TableCell>Solutions Spike Time</TableCell>
                                                        <TableCell>Arm used</TableCell>
                                                        <TableCell>Machine start time</TableCell>
                                                        <TableCell>Restick</TableCell>
                                                        <TableCell>Tech. Initial</TableCell>

                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell><TimeInput source="spike_time"
                                                                              label=""/></TableCell>
                                                        <TableCell><SelectInput source="arm_used" label=""
                                                                                choices={leftRight}/></TableCell>
                                                        <TableCell><TimeInput source="process_start_time"
                                                                              label=""/></TableCell>
                                                        <TableCell><SelectInput source="restick" label=""
                                                                                choices={OneTwo}
                                                                                defaultValue='0'/></TableCell>
                                                        <TableCell><SanitizedTextInput source="tech_init"
                                                                                       label=""/></TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            

                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>SPE Sample Collected</TableCell>
                                                        <TableCell>Disconnect Time</TableCell>
                                                        <TableCell>Volume Collected</TableCell>
                                                        <TableCell>D/C Tech. Initial</TableCell>
                                                        <TableCell>Donor drank 20oz Gatorade</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell><SelectInput choices={YesNo}
                                                                                source="sample_collected"
                                                                                label=""/></TableCell>
                                                        <TableCell><TimeInput source="disc_time"
                                                                              label=""/></TableCell>
                                                        <TableCell><SanitizedTextInput source="volume_collected_2"
                                                                                       label=""/></TableCell>
                                                        <TableCell><SanitizedTextInput source="dc_tech_init"
                                                                                       label=""/></TableCell>
                                                        <TableCell><SelectInput source="donor_gatorade"
                                                            label=""
                                                            choices={yesNo}/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Donation Comments: </TableCell>
                                                        <TableCell colSpan="3"><TextInput source="comments_donnor"
                                                                                          label=""
                                                                                          rowsMax={4} multiline
                                                                                          fullWidth/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Incident Report:</TableCell>
                                                        <TableCell colSpan={3}>
                                                            <Button
                                                            variant="outlined"
                                                            onClick={() => setOpenIncident(true)}
                                                            startIcon={
                                                                hasIncident(incidentData) ? <EditIcon color="primary" /> : <AddIcon color="primary" />
                                                            }
                                                            >
                                                            {hasIncident(incidentData) ? 'Edit Incident Report' : 'Add Incident Report'}
                                                            </Button>

                                                            {/* Summary of the stored report. Keyed off the same test as
                                                                the button and the save gate, so a report with symptoms
                                                                but no date still shows rather than silently vanishing. */}
                                                            {hasIncident(incidentData) && (
                                                            <div style={{ marginTop: 12, lineHeight: 1.6 }}>
                                                                <strong>Date:</strong> {incidentData.date}<br />
                                                                <strong>Attending Personnel:</strong> {incidentData.attendingPersonnel}<br />
                                                                <strong>QA Review:</strong> {incidentData.qaReview}<br />
                                                                <strong>Comment:</strong> {incidentData.comment}<br />
                                                                <strong>DAE Required:</strong> {incidentData.daeRequired ? 'Yes' : 'No'}<br />
                                                                <strong>File Copy Placed:</strong> {incidentData.fileCopy ? 'Yes' : 'No'}<br />
                                                                <strong>Tums Given:</strong> {incidentData.citrateTumsCount} tablets<br />
                                                                <strong>Fluids Offered:</strong> {incidentData.treatmentVasodepressor?.fluidAmount} oz<br />
                                                                <strong>Other Vasodepressor Notes:</strong> {incidentData.treatmentVasodepressor?.other}<br />

                                                                <strong>Vasodepressor Symptoms:</strong> {incidentData.symptomsVasodepressor?.join(', ') || '-'}<br />
                                                                <strong>Citrate Symptoms:</strong> {incidentData.symptomsCitrate?.join(', ') || '-'}<br />
                                                                <strong>Other Symptoms:</strong> {incidentData.symptomsOther?.join(', ') || '-'}
                                                            </div>
                                                            )}

                                                            {/* Dialog */}
                                                            <IncidentDialog
                                                            open={openIncident}
                                                            onClose={() => setOpenIncident(false)}
                                                            initialData={incidentData}
                                                            onSave={handleIncidentSave}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>

                                        </FormTab>

                                    }

                                    {(((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) > 6 &&
                                        <FormTab label="Plasma Processing">
                                            <Allergies/>
                                            <Table className={classes.formTable}>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>Processing/Packing Comments:</TableCell>
                                                        <TableCell><TextInput source="comments_packing" label=""
                                                                              multiline
                                                                              className={classes.comments}/></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Plasma processor review / Payment
                                                            initial:</TableCell>
                                                        <TableCell><SanitizedTextInput source="verified_init"
                                                                                       label=""/></TableCell>
                                                    </TableRow>
                                                    {/*<TableRow>
                        <TableCell >QA Initial (Required in case of any incident occurred):</TableCell>
                        <TableCell > <TextInput source="qa_review_init" label=""/></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell >QA Date (Required in case of any incident occurred): </TableCell>
                        <TableCell ><DateInput source="qa_review_date" label="" locales="en-us"  /></TableCell>
                    </TableRow> */}
                                                </TableBody>
                                            </Table>
                                        </FormTab>
                                    }
                                </TabbedForm>
                            </Edit>
                        }

                        {(((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).code : '') === 'PLAP' && /*  For Plasma processer */
                            <Edit
                                title='Donor Processing Worksheet'
                                {...props}
                                actions={<ProcessingEditActions/>}
                            >
                                <SimpleForm toolbar={<ProcessingToolbar/>}>
                                    <PhlebotoView/>
                                    <Allergies/>
                                    <Table className={classes.formTable}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>Processing/Packing Comments:</TableCell>
                                                <TableCell><TextInput source="comments_packing" label="" multiline
                                                                      className={classes.comments}/></TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Plasma processor review / Payment initial:</TableCell>
                                                <TableCell><TextInput source="verified_init" label=""
                                                                      validate={required()}/></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <GetKey/>
                                </SimpleForm>
                            </Edit>
                        }

                        {(((localStorage.token) ? jwt_decode(localStorage.token) : null) ? (jwt_decode(localStorage.token)).level : 0) === 4 && /*  For Phlebotomy */
                            <Edit
                                title='Donor Processing Worksheet'
                                {...props}
                                actions={<ProcessingEditActions/>}
                            >
                                <SimpleForm toolbar={<ProcessingToolbar/>}>
                                    <GetKey/>
                                    {/* Reads back the lots this donation already drew from
                                        inventory, so an edit adjusts by the difference
                                        instead of consuming twice. */}
                                    <SoftGoodUsageLoader/>
                                    <Allergies/>
                                    <Table className={classes.formTable}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>Control Number</TableCell>
                                                <TableCell>Donor weight</TableCell>
                                                <TableCell>Volume collected</TableCell>
                                                <TableCell>Machine #</TableCell>
                                                <TableCell>Soft Goods Verified for Defects and Lot Numbers
                                                    initial</TableCell>

                                            </TableRow>
                                            <TableRow>
                                                <TableCell><TextInput source="control_num" label=""
                                                                      disabled/></TableCell>
                                                <TableCell><TextInput source="weight" label="" disabled/></TableCell>
                                                <TableCell><TextInput source="volume_collected" label=""
                                                                      disabled/></TableCell>
                                                <TableCell><MachineInput validate={required()}/></TableCell>
                                                <TableCell><SanitizedTextInput source="sf_lot_init" label=""
                                                                               validate={required()}/></TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Solutions Spike Time</TableCell>
                                                <TableCell>Arm used</TableCell>
                                                <TableCell>Machine start time</TableCell>
                                                <TableCell>Restick</TableCell>
                                                <TableCell>Tech. Initial</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell><TimeInput source="spike_time" label=""
                                                                      validate={required()}/></TableCell>
                                                <TableCell><SelectInput source="arm_used" label="" choices={leftRight}
                                                                        validate={required()}/></TableCell>
                                                <TableCell><TimeInput source="process_start_time" label=""
                                                                      validate={required()}/></TableCell>
                                                <TableCell><SelectInput source="restick" label="" choices={OneTwo}
                                                                        defaultValue='0'
                                                                        validate={required()}/></TableCell>
                                                <TableCell><SanitizedTextInput source="tech_init" label=""
                                                                               validate={required()}/></TableCell>
                                            </TableRow>

                                        </TableBody>
                                    </Table>
                                    <Table className={classes.formTable}>
                                        <TableBody>
                                            {/* Same soft goods block as the supervisor tab: pick
                                                the released lots used, quantities follow, stock
                                                comes off on save. */}
                                            <SoftGoodsLotRows/>
                                            <SoftGoodsQtyRows validate={required()}/>
                                        </TableBody>
                                    </Table>

                                    <Table className={classes.formTable}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>SPE Sample Collected</TableCell>
                                                <TableCell>Disconnect Time</TableCell>
                                                <TableCell>Volume Collected</TableCell>
                                                <TableCell>D/C Tech. Initial</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell><SelectInput choices={YesNo} source="sample_collected"
                                                                        label=""
                                                                        validate={required()}/></TableCell>
                                                <TableCell><TimeInput source="disc_time" label=""
                                                                      validate={required()}/></TableCell>
                                                <TableCell><SanitizedTextInput source="volume_collected_2" label=""
                                                                               validate={required()}/></TableCell>
                                                <TableCell><SanitizedTextInput source="dc_tech_init" label=""
                                                                               validate={required()}/></TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Donor drank 20oz Gatorade:</TableCell>
                                                <TableCell colSpan="3"><SelectInput source="donor_gatorade" label=""
                                                                                    choices={yesNo}
                                                                                    validate={required()}/></TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Donation Comments: </TableCell>
                                                <TableCell colSpan="3"><TextInput source="comments_donnor" label=""
                                                                                  rowsMax={4}
                                                                                  multiline fullWidth/></TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Incident Report: </TableCell>
                                                <TableCell colSpan="3">
                                                    <TableCell colSpan="3"><GetFileUpload
                                                        classes={classes}/></TableCell>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </SimpleForm>
                            </Edit>
                        }

                    </div>
                </ErrorBoundary>
                );
                }
export default withStyles(editStyles)(ProcessingEdit);